import { render, staticRenderFns } from "./OSHNotifications.vue?vue&type=template&id=12d1f3ec&"
import script from "./OSHNotifications.vue?vue&type=script&lang=js&"
export * from "./OSHNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports